import Swiper, { Autoplay, Navigation } from "swiper";
Swiper.use([Autoplay, Navigation]);

document.addEventListener("DOMContentLoaded", () => {
  const sliderElement = document.querySelector(".main__banner__slider");
  if (!sliderElement) return;

  const slides = sliderElement.querySelectorAll(".swiper-slide");
  if (slides.length < 2) return;
  const mainBannerSlider = new Swiper(".main__banner__slider", {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    loopAdditionalSlides: 1,
    autoplay: {
      delay: 5000,
      disableOnInteraction: true,
    },
    navigation: {
      nextEl: ".main__banner__slider__descr__control--next",
      prevEl: ".main__banner__slider__descr__control--prev",
    },
  });
});
